import config from "shared/config";

export const getAuthProviderIfUnTenanted = (url: string): string | null => {
  if (url.includes("/admin")) {
    return config.adminAuthProvider;
  }
  return null;
};
